import { render, staticRenderFns } from "./BlendDetails.vue?vue&type=template&id=b607b952&scoped=true&"
import script from "./BlendDetails.vue?vue&type=script&lang=js&"
export * from "./BlendDetails.vue?vue&type=script&lang=js&"
import style0 from "./BlendDetails.vue?vue&type=style&index=0&id=b607b952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b607b952",
  null
  
)

export default component.exports